import React from 'react';

const BotViewToggle = ({ viewMode, setViewMode }) => {
    return (
        <div className="d-flex bg-light-toggle rounded-3 p-1" >
            <div 
                className={`toggle-button-div cursor-pointer d-flex align-items-center justify-content-center rounded-2 ${viewMode === 'table' ? 'toggle-active shadow-sm' : ''}`}
                style={{ width: '36px', height: '36px', transition: 'all 0.2s'}}
                onClick={() => setViewMode('table')}
            >
                <img src="/images/List.svg" alt="List View" width="20" height="20" />
            </div>
            <div 
                className={`toggle-button-div cursor-pointer d-flex align-items-center justify-content-center rounded-2 ${viewMode === 'grid' ? 'toggle-active shadow-sm' : ''}`}
                style={{ width: '36px', height: '36px', transition: 'all 0.2s' }}
                onClick={() => setViewMode('grid')}
            >
                <img src="/images/Grid.svg" alt="Grid View" width="20" height="20" />
            </div>
        </div>
    );
};

export default BotViewToggle;
